import {useMutation, useQueryClient} from "@tanstack/react-query";
import {
    archivedRoom,
    initFilter, joinRoom, leaveRoom,
    lockRoom,
    readRoom, removeRoomByUser,
    ROOM_KEY, ROOM_MESSAGES_KEY,
    ROOMS_KEY,
    updateRoom
} from "../api/public-voissa/rooms";
import {toastError} from "../libs/toast";
import {ROOM} from "../const/toasts";
import {toast} from "react-toastify";
import {USER_UNREAD_ROOMS_KEY} from "../api/public-voissa/users";


const queryKeyDefault = [ROOMS_KEY, initFilter];

export const useRoomArchived = () =>{
    const queryClient = useQueryClient();
    return useMutation(data => archivedRoom(data.roomId, {archived: data.isAchived}),{
        onSuccess: async (data, variables) =>{
            await queryClient.invalidateQueries([ROOMS_KEY, {...initFilter, archived : false}]);
            await queryClient.invalidateQueries([ROOMS_KEY, {...initFilter, archived : true}]);
            await queryClient.invalidateQueries([ROOM_KEY, data._id]);
            if(variables.isAchived){
                toast("Cette conversation vient d'être archivée. Vous pouvez retrouver les conversations archivées en cliquant sur Filtres / Conversations archivées.",{
                    autoClose: 15000,
                    className: 'toast-background toast-success',
                    bodyClassName: "toast-font toast-success",
                    progressClassName: 'toast-loader toast-success'
                });
            }
        },
        onError: () =>{
            toastError(ROOM.ERROR.UPDATE);
        }
    });
}

export const useRoomChangeTitle = ({
        queryKey = queryKeyDefault
    }) =>{

    const queryClient = useQueryClient();
    return useMutation(data => updateRoom(data.roomId, {groupName: data.groupName}),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries(queryKey);

            //await queryClient.invalidateQueries([ROOM_KEY, data._id]);

            queryClient.setQueryData([ROOM_KEY, data._id], oldData => {
                return {
                    ...oldData,
                    ...data
                }
            });
        },
        onError: () =>{
            toastError(ROOM.ERROR.UPDATE);
        }
    });
}

export const useRoomMarkRead = ({
       queryKey = queryKeyDefault
   }) =>{
    const queryClient = useQueryClient();


    return useMutation(data => readRoom(data.roomId, {read: data.read}),{
        onSuccess: async (_, variables) =>{
            await queryClient.invalidateQueries([USER_UNREAD_ROOMS_KEY]);
            const previousValue = queryClient.getQueryData(queryKey);
            if (previousValue) {
                let newPagesArray = previousValue?.pages.map((page) => {
                        page.data = page.data.map((item) => {
                            if (item._id.toString() === variables.roomId) {
                                item = {...item, isReadByCurrentUser : variables.read};
                            }
                            return item;
                        });
                        return page;
                    }
                ) ?? [];

                queryClient.setQueryData(queryKey, oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }
            //await queryClient.invalidateQueries([ROOM_KEY, variables.roomId]);
        },
        onError: () =>{
            toastError(ROOM.ERROR.UPDATE);
        }
    });

}

export const useRoomLocked = ({
         queryKey = queryKeyDefault
     }) =>{

    const queryClient = useQueryClient();
    return useMutation(data => lockRoom(data.roomId, {locked: data.locked}),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries(queryKey);
            await queryClient.invalidateQueries([ROOM_KEY, data._id]);
        },
        onError: () =>{
            toastError(ROOM.ERROR.UPDATE);
        }
    });
}

export const useRoomUserLeave = ({
       queryKey = queryKeyDefault
   }) =>{

    const queryClient = useQueryClient();
    return useMutation(data => leaveRoom(data.roomId, {userId: data.userId}),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries(queryKey);
            await queryClient.invalidateQueries([ROOM_KEY, data._id]);
            await queryClient.invalidateQueries([ROOM_MESSAGES_KEY, data._id]);
        },
        onError: () =>{
            toastError(ROOM.ERROR.UPDATE);
        }
    });
}


export const useRoomUserJoin = ({
         queryKey = queryKeyDefault
     }) =>{

    const queryClient = useQueryClient();
    return useMutation(data => joinRoom(data.roomId, {userId: data.userId}),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries(queryKey);
            await queryClient.invalidateQueries([ROOM_KEY, data._id]);
            await queryClient.invalidateQueries([ROOM_MESSAGES_KEY, data._id]);
        },
        onError: () =>{
            toastError(ROOM.ERROR.UPDATE);
        }
    });
}

export const useRoomRemoveByUser = ({
        queryKey = queryKeyDefault
    }) =>{

    const queryClient = useQueryClient();
    return useMutation(roomId => removeRoomByUser(roomId),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries(queryKey);
            await queryClient.invalidateQueries([ROOM_KEY, data._id]);
        },
        onError: () =>{
            toastError(ROOM.ERROR.UPDATE);
        }
    });
}

